import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom-v5-compat";

import { MODAL_ROUTES } from "routing/routes";
import loaderWithRetry from "seneca-common/utils/loaderWithRetry";

const UnlockDarkModeModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "unlock-dark-mode-chunk" */
        "features/dark-mode/components/UnlockDarkModeModal"
      )
  )
);

const ShareAssignmentModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "share-assignment-chunk" */
        "features/teachers/pages/assignment/modals/AssignmentShareModal"
      )
  )
);

const MultipleAssignmentShareModal = lazy(() =>
  loaderWithRetry(
    () =>
      import(
        /* webpackChunkName: "share-assignment-chunk" */
        "features/teachers/pages/assignment/modals/MultipleAssignmentShareModal"
      )
  )
);

export function ModalRoutes() {
  return (
    <Routes>
      <Route
        path={MODAL_ROUTES.UNLOCK_DARK_MODE.path}
        element={
          <Suspense>
            <UnlockDarkModeModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.SHARE_ASSIGNMENT.path}
        element={
          <Suspense>
            <ShareAssignmentModal />
          </Suspense>
        }
      />
      <Route
        path={MODAL_ROUTES.SHARE_ASSIGNMENTS.path}
        element={
          <Suspense>
            <MultipleAssignmentShareModal />
          </Suspense>
        }
      />
    </Routes>
  );
}
